import React, { useEffect, useRef } from "react";
import { Player, LoadingSpinner, BigPlayButton, ControlBar, PlayToggle, ProgressControl } from "video-react";
import "video-react/dist/video-react.css";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";
import { TranslateProvider, useTranslation } from "../i18n";

const VideoViewer = ({
  isShow,
  onClose,
  video,
  title,
  langCode = "en"
}) => {
  const {
    _t,
    setLanguage
  } = useTranslation();
  useEffect(() => {
    setLanguage(langCode);
  }, [langCode, setLanguage]);
  const player = useRef(null);

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "videoFullScreen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoFullScreen-backdrop",
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "videoFullScreen-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoFullScreen-title"
  }, title), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    size: "small",
    className: "videoFullScreen-close",
    onClick: onClose,
    endIcon: /*#__PURE__*/React.createElement(CloseIcon, null)
  }, _t("Закрыть")), /*#__PURE__*/React.createElement(Player, {
    ref: player,
    src: video,
    preload: "auto",
    autoPlay: true,
    loop: true,
    className: "videoFullScreen-video"
  }, /*#__PURE__*/React.createElement(ControlBar, {
    autoHide: false,
    disableDefaultControls: true
  }, /*#__PURE__*/React.createElement(PlayToggle, null), /*#__PURE__*/React.createElement(ProgressControl, null)), /*#__PURE__*/React.createElement(BigPlayButton, {
    position: "center"
  }), /*#__PURE__*/React.createElement(LoadingSpinner, null))));
};

const VideoViewerWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(VideoViewer, props));
};

export default VideoViewerWrapper;